import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppConfig } from '../../app.config';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';
import { PHBHPFeaturePackageInsitutionManagementService } from 'src/app/institution/ph-bhp-feature-package-insitution-management.service';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';

@Component({
  selector: 'app-configure',
  templateUrl: './configure.component.html',
  styleUrls: ['./configure.component.css']
})
export class ConfigureComponent implements OnInit, OnDestroy {

  userData: any;
  subscription: Subscription;
  showWard = true;
  institutionSubscription: Subscription;
  packageId: Number;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  packageSubscription: any;
  isMyHygieneSOPLicense: boolean = false;
  isObserveLicense: boolean = false;
  isHygieneCheckLicense: boolean = false;
  institutions;
  InstitutionsList: Array<any>;

  constructor(public config: AppConfig, public layoutService: PHBHPLayoutPackageService, private router: Router, private listservice: PHBHPListApiService,
    public insitution: PHBHPFeaturePackageInsitutionManagementService, public configService: PHBHPFeaturePackageConfigurationService) { }

  ngOnInit() {
    if (this.layoutService.packageID) {
      this.packageDetails();
    }
    this.subscription = this.layoutService.packageIDSubject.asObservable().subscribe((packageID) => {
      this.packageDetails();
    });
    if (this.config.userData && this.config.userData.roleName.roleId === 3) {
      this.showWard = false;
      if (this.layoutService.institutionID) {
        this.getinstitutionDetails(this.layoutService.institutionID);
      }
    }

    this.institutionSubscription = this.layoutService.institutionIDSubject.asObservable().subscribe(res => {
      this.getinstitutionDetails(res);
      this.institutions = this.config.institutions;
      this.getInstitutionsDetails()
    });

    this.institutions = this.config.institutions;
    if (this.institutions && this.institutions.length > 0) {
      this.getInstitutionsDetails()
    } else {
      this.isMyHygieneSOPLicense = true;
      this.isObserveLicense = true;
    }

    if (this.config.userData && this.config.userData.roleName.roleId == 4) {
      var selectedInstitutionId = this.layoutService.institutionID;
      this.configService.getConfigDetails(selectedInstitutionId).subscribe((res: any) => {
        this.layoutService.showSubCategoryLink = res.enableProfessionalSubCategory;
      });
    }
  }

  getInstitutionsDetails() {
    this.insitution.getInstitutionsbyId(this.institutions, this.config.userData.roleName.roleId).subscribe((res: any) => {
      this.InstitutionsList = res;
      this.setInstitutionPackage();
    });
  }

  setInstitutionPackage() {
    if (this.InstitutionsList && this.InstitutionsList.length > 0) {
      const institution = this.InstitutionsList.find(x => x.institution?.institutionID === this.layoutService?.institutionID)?.institution;
      let packageId = institution?.packageID || this.layoutService.packageID;
      if (packageId)
      {
        this.isMyHygieneSOPLicense = this.layoutService.isMyHygieneSOPLicense(packageId);
        this.isObserveLicense = this.layoutService.isObserveLicense(packageId);
        this.isHygieneCheckLicense = this.layoutService.isHygieneCheckLicense(packageId);
      }
    }
  }

  packageDetails() {
    var packageID = this.layoutService.packageID;
    this.packageId = packageID;
  }

  getinstitutionDetails(institutionid) {
    this.layoutService.showLoader = true;
    this.listservice.getInstitutionsbyId(institutionid, this.config.userData.roleName.roleId).subscribe((res: any) => {
      const selectedInstitution = res.find(x => x.institution.institutionID === institutionid);
      if (selectedInstitution) {
        if (selectedInstitution.institution.isGroup) {
          this.showWard = false;
        } else {
          this.showWard = true;
        }
      } else {
        this.showWard = true;
      }
    });
    this.layoutService.showLoader = false;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.institutionSubscription) {
      this.institutionSubscription.unsubscribe();
    }
  }

  get canShowWardLink(): boolean {
    return this.config.userData &&
           (this.config.userData.roleName.roleId == 3 || this.config.userData.roleName.roleId == 4) &&
           this.showWard;
  }

  get canShowImageInstitutionLink(): boolean {
    return this.config.userData &&
           (this.config.userData.roleName.roleId == 3 || this.config.userData.roleName.roleId == 4 ) &&
           this.isMyHygieneSOPLicense;
  }

  get canShowCommentsLink(): boolean {
    return this.config.userData &&
      ((this.config.userData.roleName.roleId == 1 || this.config.userData.roleName.roleId == 2) ||
        ((this.config.userData.roleName.roleId == 3 || this.config.userData.roleName.roleId == 4) && (this.isMyHygieneSOPLicense || this.isObserveLicense)));
  }

  get canShowCheckCommentsLink(): boolean {
    return this.config.userData &&
      ((this.config.userData.roleName.roleId == 1) ||
        ((this.config.userData.roleName.roleId == 3 || this.config.userData.roleName.roleId == 4) && (this.isHygieneCheckLicense)));
  }

  get canShowCheckPredefinedCommentsLink(): boolean {
    return this.config.userData && this.config.userData.roleName.roleId == 2;
  }

  get canShowSubCategoryLink(): boolean {
    if (this.config.userData.roleName.roleId != 4) return true;

    return this.layoutService.showSubCategoryLink;
  }
}
